<template>
  <div class="page relate-protocol">
    <navigation>相关协议</navigation>
    <div class="navigate-list">
      <nd-cell class="navigate-item" v-for="(item, index) in signList" :id="index" :key="index" :title="item.title" @click="clickProtocol(item)"></nd-cell>
    </div>
  </div>
</template>

<script>
export default {
  name: 'bankcardPayProtocol',
  customReadyNotify: true,
  data () {
    const proOrgin = process.env.VUE_APP_PROURL
    console.log(4444, process.env, proOrgin)
    return {
      signList: [{
        title: '委托扣款协议',
        path: location.origin + '/protocol/entrust'
      }, {
        title: '宝付网络科技',
        path: `${proOrgin}/protocol/bank/baofoo`
      }, {
        title: '广发银行',
        path: `${proOrgin}/protocol/bank/guangfa`
      }, {
        title: '贵州银行',
        path: `${proOrgin}/protocol/bank/guizhou`
      }, {
        title: '杭州银行',
        path: `${proOrgin}/protocol/bank/hangzhou`
      }, {
        title: '恒丰银行',
        path: `${proOrgin}/protocol/bank/hengfeng`
      }, {
        title: '华夏银行',
        path: `${proOrgin}/protocol/bank/huaxia`
      }, {
        title: '中国农业银行',
        path: `${proOrgin}/protocol/bank/nongye`
      }, {
        title: '平安银行',
        path: `${proOrgin}/protocol/bank/pingan`
      }, {
        title: '浦发银行',
        path: `${proOrgin}/protocol/bank/pufa`
      }, {
        title: '上海银行',
        path: `${proOrgin}/protocol/bank/shanghai`
      }, {
        title: '招商银行',
        path: `${proOrgin}/protocol/bank/zhaoshang`
      }, {
        title: '中国工商银行',
        path: `${proOrgin}/protocol/bank/gongshang`
      }, {
        title: '光大银行',
        path: `${proOrgin}/protocol/bank/guangda`
      }, {
        title: '中国建设银行',
        path: `${proOrgin}/protocol/bank/jianshe`
      }, {
        title: '民生银行',
        path: `${proOrgin}/protocol/bank/minsheng`
      }, {
        title: '中国银行',
        path: `${proOrgin}/protocol/bank/zhongguo`
      }, {
        title: '邮政储蓄银行',
        path: `${proOrgin}/protocol/bank/youzheng`
      }, {
        title: '中信银行',
        path: `${proOrgin}/protocol/bank/zhongxin`
      }]
    }
  },
        
  async created () {
    this.$bus.$emit('ready')
  },
        
  methods: {
    clickProtocol (item) {
      window.location.href = item.path
    }
  }
}
</script>

<style lang="less">
@import "../../assets/less/mixin.less";

.relate-protocol {
  background-color: #fafafa;
  .header {
    .description {
      color: @fc2;
      font-family: PingFangSC-Regular,PingFang SC;
      font-size: 26px;
      line-height: 100px;
      padding-left: 30px;
      font-weight: 400;
    }
  }
  .navigate-list{
    padding-top: 20px;
    .navigate-item {
      height: 110px;
      line-height: 110px;
      margin-top: 0px;
      padding-left: 15px;
      padding-right: 17px;
      border-bottom: 1px solid @iuc;
    }
  }
}
</style>